import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import TableHead from './TableHead/TableHead';
import Link from './Link';
import { humanizeConversion } from '~/common';

const TableLeft = (props) => {
    return (
        <TableContainer className="table-container-left">
            <Table>
                <TableHead report={props.report}/>
                <TableBody>
                    {Object.keys(props.report).map((key, id) => (
                        <TableRow key={id}>
                            <TableCell className="primary">
                                <Typography noWrap={true}><Link value={key.substring(1)}/></Typography>
                            </TableCell>
                            <TableCell className="total">
                                <Typography>{props.report[key].total}</Typography>
                            </TableCell>
                            <TableCell className="avg">
                                <Typography>{humanizeConversion(props.report[key].conversion)}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

TableLeft.propTypes = {
    report: PropTypes.object.isRequired,
};

export default TableLeft;
